import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BillTotal,
  CalculateTaxForCommonTax,
  MainBillTotal,
} from "../../../../CommonFunction/CalculateGST/CalculateTax";
import { Addition, Subtraction } from "../../../../CommonFunction/CalculationsWithDecimalValues";
import Input from "../../Input/Input";
import { getTotalForFreightBill } from "../../InvoceComponents/RelatedFunctions";
import { SalesBillFormulaTable } from "../AddLMSSalesBill/RelatedTables/SalesBillFormulaTable";
import InputWithDropdown from "../../InvoceComponents/InputWithDropdown";
import { WarningToast } from "../../ToastComponent/RectHotToast";

export const TaxTabel = ({
  Form_Key,
  tableData,
  lastModified,

  Formula,
  setFormula,
  isFirstLoad,
  setFirstLoad,
  InvoiceType,
  FormData,
  selectedOption,
  setSelectedOption,
  DiscAndRound,
  setDiscAndRound,
}) => {
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const MasterData = useSelector((store) => store?.FormDataReducer?.MasterData?.[Form_Key]);
  const dispatch = useDispatch();
  const options = ["₹", "%"];
  const calculateDiscountAmount = () => {
    let base = getTotalForFreightBill(tableData) || 0;

    if (DiscAndRound?.value) {
      if (DiscAndRound.unit === "₹") return Number(DiscAndRound.value);
      if (DiscAndRound.unit === "%") return Number(((Number(DiscAndRound.value) / 100) * base).toFixed(2));
    }
    return 0;
  };

  useEffect(() => {
    async function processData() {
      let arr = [];
      const CommonTaxGroup = FormDataFromRedux?.MasterData[Form_Key]?.Tax_Group; //
      let itemTotalAmount = getTotalForFreightBill(tableData);
      const discountAmount = calculateDiscountAmount();
      itemTotalAmount = Subtraction(itemTotalAmount, discountAmount);
      if (CommonTaxGroup?._id) {
        let updatedData = CalculateTaxForCommonTax(
          CommonTaxGroup?.Selected_Taxes,
          itemTotalAmount,
          InvoiceType,
          FormData
        );

        arr = updatedData;
      } else if (FormData?.Tax === "Common") {
        setFormula([]);
      }

      let billTotal = BillTotal([
        {
          Amount: itemTotalAmount,
        },
        ...arr,
      ]);

      let unroundedTotal = BillTotal([{ Amount: itemTotalAmount }, ...arr]);
      let per = MasterData?.["TDSTCS"]?.Tax_Percentage
        ? ((Number(MasterData?.["TDSTCS"]?.Tax_Percentage) / 100) * Number(itemTotalAmount)).toFixed(2) || 0
        : 0;
      unroundedTotal = Subtraction(unroundedTotal, per);
      const roundedTotal = DiscAndRound?.applyRoundOff ? Math.round(unroundedTotal) : unroundedTotal;
      const roundOffAmount = Addition(roundedTotal, -unroundedTotal);
      console.log(unroundedTotal, per, roundedTotal, roundOffAmount);
      setDiscAndRound((prev) => ({ ...prev, roundOff: roundOffAmount }));

      if (Form_Key === "Purchase_Bill" || Form_Key === "Vendor_Freight_Bill") {
        setSelectedOption((prev) => {
          return {
            ...prev,
            TDSTCSRate: MasterData?.["TDSTCS"]?.Tax_Percentage,
            TDSTCSAmount: Number.isFinite(Number(per)) ? Number(per) : 0,
          };
        });
      }
      let DisAcc = FormDataFromRedux?.MasterData["Preference"]?.Discount_Account;
      if (arr.length) {
        let DisAcc = FormDataFromRedux?.MasterData["Preference"]?.Discount_Account;
        if (!DisAcc?._id && FormData?.Tax == "Common") {
          WarningToast("Select Discount Account");
        }

        let RoundAcc = FormDataFromRedux?.MasterData[Form_Key]?.RoundOffAcc;
        if (!RoundAcc?._id && DiscAndRound.applyRoundOff) {
          WarningToast("Create Round Off Account");
        }
        setFormula([
          {
            Name: "Discount",
            Amount: discountAmount,
            Transaction_Type: "Cr",
            Input_Account: {
              ...DisAcc,
              _id: DisAcc?.Account_Balance_Id ? DisAcc?.Account_Balance_Id : DisAcc?._id,
            },
            Output_Account: {
              ...DisAcc,

              _id: DisAcc?.Account_Balance_Id ? DisAcc?.Account_Balance_Id : DisAcc?._id,
            },
            Discount: DiscAndRound?.value,
            unit: DiscAndRound?.unit,
          },
          {
            Name: "Taxable Amount",
            Amount: itemTotalAmount,
          },
          ...arr,
          {
            Name: "Round Off",
            Amount: DiscAndRound?.applyRoundOff ? (roundOffAmount < 0 ? -1 * roundOffAmount : roundOffAmount) : 0,
            Transaction_Type:
              !DiscAndRound?.applyRoundOff || roundOffAmount === 0
                ? ""
                : InvoiceType === "Sales"
                ? roundOffAmount > 0
                  ? "Cr"
                  : "Dr"
                : InvoiceType === "Purchase"
                ? roundOffAmount > 0
                  ? "Dr"
                  : "Cr"
                : "",
            // Transaction_Type: roundOffAmount > 0 ? "Cr" : roundOffAmount < 0 ? "Dr" : "",
            Rate: 0,
            Apply: DiscAndRound?.applyRoundOff,
            Input_Account: RoundAcc,
            Output_Account: RoundAcc,
            applyRoundOff: DiscAndRound.applyRoundOff,
          },
          {
            Name: "Total",
            Amount: roundedTotal || 0,
            Transaction_Type: InvoiceType === "Sales" ? "Dr" : InvoiceType === "Purchase" ? "Cr" : "",
            Calculation_Type: "Total",
          },
        ]);
      }
    }
    console.log(FormData?.Party, isFirstLoad);
    if (FormData?.Party && isFirstLoad) {
      processData();
    }
  }, [
    lastModified,
    FormData?.Tax_Group,
    FormData?.Party,
    FormDataFromRedux?.MasterData[Form_Key]?.Tax_Group,
    FormDataFromRedux?.MasterData[Form_Key]?.Party,
    FormDataFromRedux?.MasterData[Form_Key]?.TDSTCS,
    tableData,
    FormData?.RCM,
    FormData?.Tax,
    isFirstLoad,
    DiscAndRound?.value,
    DiscAndRound?.unit,
    DiscAndRound?.applyRoundOff,
  ]);

  const handleChange = (event) => {
    setSelectedOption((prev) => {
      return { ...prev, TDSTCSData: "" };
    });
    if (MasterData && MasterData["TDSTCS"]) {
      dispatch({
        type: "StoreMasterData",
        payload: {
          Form_Key,
          data: { ["TDSTCS"]: "" },
        },
      });
    }

    setSelectedOption({
      TDSTCSData: "",
      TDSTCSAmount: "",
      TDSTCSRate: "",
      selectedRadioOption: event.target.value,
    });
  };
  const handleTDSTCS = (e) => {
    setFirstLoad(true);
    if (e.target.value) {
      setSelectedOption((prev) => {
        return { ...prev, TDSTCSData: e.target.value };
      });
    } else if (e.target.value === "") {
      setSelectedOption((prev) => ({
        ...prev,
        TDSTCSData: "",
        TDSTCSRate: "",
        TDSTCSAmount: "",
      }));
    }
  };

  return (
    <>
      {Formula?.length ? (
        <table className="salesBillTable">
          <thead>
            <tr>
              <th>Name</th>
              <th>Cr/Dr</th>
              <th>Rate</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {Formula?.map((el, i) => {
              if (el.Name == "Discount") {
                return (
                  <tr>
                    <td>Discount</td>
                    <td className="discount-cell">
                      <InputWithDropdown
                        setFirstLoad={setFirstLoad}
                        options={options}
                        DiscAndRound={DiscAndRound}
                        setDiscAndRound={setDiscAndRound}
                        FormData={FormData}
                      />
                    </td>
                    <td>{DiscAndRound.unit === "%" ? `${DiscAndRound.value || 0}%` : ""}</td>
                    <td>{el?.Amount}</td>
                  </tr>
                );
                // } else if (el.Name === "Total") {
                //   return (
                //     <>
                //       {(Form_Key === "Purchase_Bill" || Form_Key === "Vendor_Freight_Bill") && (
                //         <tr>
                //           <td>
                //             <label htmlFor="inputText">TDS</label>
                //           </td>
                //           <td className="table-container-input-dropdown">
                //             <Input
                //               EMTQuery=""
                //               checked={""}
                //               InputConfig={{
                //                 masterName: selectedOption?.selectedRadioOption,
                //               }}
                //               value={selectedOption?.TDSTCSData}
                //               type="InputDropForQuery"
                //               name="TDSTCS"
                //               handleBlur={() => {}}
                //               label={"No Label"}
                //               modalform={true}
                //               Iconinside={true}
                //               transactions={true}
                //               TypeOfPortal={""}
                //               handleInputChange={(e) => {
                //                 handleTDSTCS(e);
                //               }}
                //               Tax_Type={true}
                //               formkey={Form_Key}
                //             />
                //           </td>
                //           <td className="numberColumn">{selectedOption?.TDSTCSRate}</td>
                //           <td>{selectedOption?.TDSTCSAmount}</td>
                //         </tr>
                //       )}
                //       <SalesBillFormulaTable el={el} index={i} handleDelete={() => {}} handleFormulaChange={() => {}} />
                //     </>
                //   );
              } else if (el.Name === "Round Off") {
                return (
                  <>
                    {(Form_Key === "Purchase_Bill" || Form_Key === "Vendor_Freight_Bill") && (
                      <tr>
                        <td>
                          <label htmlFor="inputText">TDS</label>
                        </td>
                        <td className="table-container-input-dropdown">
                          <Input
                            EMTQuery=""
                            checked={""}
                            InputConfig={{
                              masterName: selectedOption?.selectedRadioOption,
                            }}
                            value={selectedOption?.TDSTCSData}
                            type="InputDropForQuery"
                            name="TDSTCS"
                            handleBlur={() => {}}
                            label={"No Label"}
                            modalform={true}
                            Iconinside={true}
                            transactions={true}
                            TypeOfPortal={""}
                            handleInputChange={(e) => {
                              handleTDSTCS(e);
                            }}
                            Tax_Type={true}
                            formkey={Form_Key}
                          />
                        </td>
                        <td className="numberColumn">{selectedOption?.TDSTCSRate}</td>
                        <td>{selectedOption?.TDSTCSAmount}</td>
                      </tr>
                    )}
                    <tr>
                      <td>Round Off</td>
                      <td>{el?.Transaction_Type}</td>
                      <td>
                        <label>
                          <input
                            type="checkbox"
                            checked={DiscAndRound?.applyRoundOff}
                            onChange={() => {
                              setDiscAndRound((prev) => ({ ...prev, applyRoundOff: !prev?.applyRoundOff }));
                              setFirstLoad(true);
                            }}
                          />
                          {
                            //roundOff > 0 ? "Add" : roundOff < 0 ? "Reduce" : ""
                          }
                        </label>
                      </td>
                      <td>{DiscAndRound?.applyRoundOff ? Math.abs(DiscAndRound?.roundOff).toFixed(2) : "-"}</td>
                    </tr>
                  </>
                );
              } else {
                return (
                  <SalesBillFormulaTable
                    key={i}
                    el={el}
                    index={i}
                    handleDelete={() => {}}
                    handleFormulaChange={() => {}}
                  />
                );
              }
            })}

            {/* {Formula.filter((el) => el.Name !== "Discount" && el.Name !== "Round Off" && el.Name !== "Total").map(
              (el, i) => (
                <SalesBillFormulaTable
                  key={i}
                  el={el}
                  index={i}
                  handleDelete={() => {}}
                  handleFormulaChange={() => {}}
                />
              )
            )}

            <tr>
              <td>Round Off</td>
              <td>{Formula.find((el) => el.Name === "Round Off")?.Transaction_Type}</td>
              <td>
                <label>
                  <input
                    type="checkbox"
                    checked={DiscAndRound?.applyRoundOff}
                    onChange={() => {
                      setDiscAndRound((prev) => ({ ...prev, applyRoundOff: !prev?.applyRoundOff }));
                      setFirstLoad(true);
                    }}
                  />
                  {
                    //roundOff > 0 ? "Add" : roundOff < 0 ? "Reduce" : ""
                  }
                </label>
              </td>
              <td>{DiscAndRound?.applyRoundOff ? Math.abs(DiscAndRound?.roundOff).toFixed(2) : "-"}</td>
            </tr>

            {Formula.find((el) => el.Name === "Total") && (
              <SalesBillFormulaTable
                el={Formula.find((el) => el.Name === "Total")}
                index={Formula.length - 1}
                handleDelete={() => {}}
                handleFormulaChange={() => {}}
              />
            )} */}
          </tbody>
        </table>
      ) : null}
    </>
  );
};
